import React, { useEffect, useState } from "react";

import { formatNumber, matchGeoFirstAndLastCoords, useGetFieldDetails, useGetFieldShape, useTranslation } from "utils";

import { Coordinates, FieldShape } from "models";

import { Card, Divider, Flex, MapStatic, Spin, Tag } from "components";

type FarmFieldCardProps = {
  fieldId: string;
  dataTestId?: string;
  onClick?: () => void;
};

export const FarmFieldCard = ({ fieldId, dataTestId, onClick = () => {} }: FarmFieldCardProps) => {
  const { t } = useTranslation("modules");
  const { fieldShape } = useGetFieldShape({ fieldId });
  const { data: fieldDetails } = useGetFieldDetails({ id: fieldId });
  const [geometry, setGeometry] = useState<FieldShape>();
  const [location, setLocation] = useState<Coordinates>();

  useEffect(() => {
    if (fieldShape) {
      setGeometry({ ...fieldShape, geometry: matchGeoFirstAndLastCoords(fieldShape.geometry) });
    }
  }, [fieldShape]);

  useEffect(() => {
    if (fieldDetails) {
      setLocation(fieldDetails.location);
    }
  }, [fieldDetails]);

  return (
    <Card dataTestId={dataTestId} className="farm-field-card" mixpanelText="field-card">
      <Flex vertical gap="0.5rem" className="field-details">
        <Flex vertical justify="center">
          <span className="paragraph-m grey-600-text">
            {!fieldDetails?.reviewed && <Tag text={t("add.fieldCard.missingData")} colour="red" size="large" />}
            {fieldDetails?.number ? t("add.fieldCard.fieldNumber", { fieldNumber: fieldDetails.number }) : t("add.fieldCard.unknownFieldNumber")}
          </span>
          <div className="name" onClick={onClick}>
            <h4>{fieldDetails?.name}</h4>
          </div>
        </Flex>
        <Divider />
        <Flex vertical justify="center">
          <div className="map-container">
            {/* @ts-expect-error need to convert to tsx */}
            {!location ? <Spin /> : <MapStatic geometry={geometry} location={location} marker />}
          </div>
          <div className="size">
            <span className="paragraph-m grey-600-text">{formatNumber({ number: parseFloat(fieldDetails?.size?.toString() || "0") })}ha</span>
          </div>
        </Flex>
      </Flex>
    </Card>
  );
};
